import dayjs, { Dayjs } from 'dayjs';

export type PatientNote = {
  id: number;
  content: string;
  createdAt: Dayjs;
  updatedAt: Dayjs;
};

export type NewPatientNote = {
  content: string;
};

export type UpdatedPatientNote = {
  content: string;
};

export type NewPatientNoteResult = {
  id: number;
  content: string;
  createdAt: Dayjs;
  updatedAt: Dayjs;
};

export interface PatientNotesMixin {
  fetch(path: string, init?: RequestInit): Promise<any>;
  patientNotesList(patientId: number): Promise<PatientNote[]>;
  patientNotesCreate(patientId: number, newNote: NewPatientNote): Promise<NewPatientNoteResult>;
  patientNotesUpdate(
    patientId: number,
    noteId: number,
    updatedNote: UpdatedPatientNote
  ): Promise<PatientNote>;
  patientNotesDestroy(patientId: number, noteId: number): Promise<undefined>;
}

export const PatientNotesMixin = {
  async fetch(path: string, init?: RequestInit): Promise<any> {
    throw new Error('Not implemented');
  },

  async patientNotesList(patientId: number): Promise<PatientNote[]> {
    const notes = await this.fetch(`/patients/${patientId}/patient_notes`);
    return notes;
  },

  async patientNotesCreate(
    patientId: number,
    newNote: NewPatientNote
  ): Promise<NewPatientNoteResult> {
    const res = await this.fetch(`/patients/${patientId}/patient_notes`, {
      method: 'POST',
      body: JSON.stringify(newNote),
    });
    return res;
  },

  async patientNotesUpdate(
    patientId: number,
    noteId: number,
    updatedNote: UpdatedPatientNote
  ): Promise<PatientNote> {
    const res = await this.fetch(`/patients/${patientId}/patient_notes/${noteId}`, {
      method: 'PUT',
      body: JSON.stringify(updatedNote),
    });
    return res;
  },

  async patientNotesDestroy(patientId: number, noteId: number): Promise<undefined> {
    await this.fetch(`/patients/${patientId}/patient_notes/${noteId}`, { method: 'DELETE' });
  },
} as PatientNotesMixin;
